export interface HotItem {
  id: string;
  title: string;
  categoryId: string;
  heat: string;
  tag: string;
}

export const hotList: HotItem[] = [
  {
    id: "h-01",
    title: "热播综艺名场面盘点：这一季凭什么让全网疯狂刷屏？",
    categoryId: "yule",
    heat: "982.3万",
    tag: "爆",
  },
  {
    id: "h-02",
    title: "深夜路透生图流出，这个下班的背影成了网友讨论焦点",
    categoryId: "mingxing",
    heat: "763.1万",
    tag: "热",
  },
  {
    id: "h-03",
    title: "不服来战：这期搞笑挑战赛，笑到隔壁桌都来围观",
    categoryId: "gaoxiao",
    heat: "641.8万",
    tag: "爆",
  },
  {
    id: "h-04",
    title: "暴雨中的暖心一幕：陌生人接力为公交司机撑伞",
    categoryId: "shehui",
    heat: "512.4万",
    tag: "热",
  },
  {
    id: "h-05",
    title: "百万粉丝直播间幕后：一场爆火直播是怎么准备的",
    categoryId: "wanghong",
    heat: "437.6万",
    tag: "热",
  },
  {
    id: "h-06",
    title: "实拍现场：纪录片视角下的城市清晨，每一帧都是壁纸",
    categoryId: "hipai",
    heat: "285.9万",
    tag: "新",
  },
];

export interface FeaturedItem {
  id: string;
  title: string;
  categoryId: string;
  excerpt: string;
  author: string;
  imageUrl: string;
}

export const featured: FeaturedItem[] = [
  {
    id: "f-01",
    title: "年度综艺名场面大赏：这十帧让你重新认识综艺的魅力",
    categoryId: "yule",
    excerpt: "高能、反转、笑点与泪点并存，我们从一整年的综艺切片里，为你挑出最值得回味的十帧。",
    author: "编辑精选",
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20bold%20cinema%20scene%20wall%20with%20glowing%20play%20icons%20and%20stars%2C%20warm%20coral%20red%20amber%20and%20cream%20palette%2C%20strong%20dynamic%20cinematic%20light%2C%20high%20detail%2C%20no%20text%2C%2016:10%20composition&width=1200&height=760&seq=featured-01&orientation=landscape",
  },
  {
    id: "f-02",
    title: "从直播间到街头，网红经济的真实一面被镜头记录了下来",
    categoryId: "wanghong",
    excerpt: "聚光灯下与镜头之外，这份实录带你看清网红日常与内容创作背后的真实温度。",
    author: "深度栏目",
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20diverse%20creator%20faces%20around%20glowing%20phones%20and%20stars%20with%20warm%20coral%20and%20amber%20accents%20on%20cream%20background%2C%20modern%20documentary%20editorial%20style%2C%20high%20detail%2C%20no%20text%2C%2016:10%20composition&width=1200&height=760&seq=featured-02&orientation=landscape",
  },
  {
    id: "f-03",
    title: "镜头即正义：社会现场背后的记录者，都在拍些什么",
    categoryId: "hipai",
    excerpt: "从一线现场到幕后运镜，我们把镜头背后的选择与坚持，一次讲给你听。",
    author: "专题策划",
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20cinematic%20documentary%20filmmaker%20silhouette%20holding%20camera%20toward%20a%20glowing%20horizon%2C%20warm%20coral%20amber%20and%20cream%20palette%2C%20evocative%20storytelling%20light%2C%20high%20detail%2C%20no%20text%2C%2016:10%20composition&width=1200&height=760&seq=featured-03&orientation=landscape",
  },
];

export const hotWords: { word: string; heat: number }[] = [
  { word: "综艺名场面", heat: 98 },
  { word: "红毯造型", heat: 92 },
  { word: "直播间幕后", heat: 86 },
  { word: "深夜路透", heat: 81 },
  { word: "神反转", heat: 79 },
  { word: "街头烟火气", heat: 74 },
  { word: "搞笑挑战", heat: 71 },
  { word: "航拍大片", heat: 68 },
  { word: "正能量暖闻", heat: 64 },
  { word: "探店实录", heat: 60 },
  { word: "采访花絮", heat: 55 },
  { word: "生图讨论", heat: 51 },
];

export const siteStats = [
  { label: "瓜料更新", value: "每日 300+ 条" },
  { label: "覆盖分类", value: "6 大主题" },
  { label: "全网热播", value: "实时同步" },
  { label: "网友互动", value: "百万热评" },
];